import '@idexx-laboratories/spot/dist/spot_library.min.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router';
import Callback from './pages/Callback/Callback';
import Deployment from './pages/Deployment/Deployment';
import paths from './paths';
import RootProvider from './RootProvider';
import './styles/index.scss';

// Create the browser router with data router API
const router = createBrowserRouter([
  {
    path: '/',
    element: <RootProvider />,
    children: [
      // Dynamic routes from paths configuration
      ...paths
        .filter(path => path.route)
        .map(path => {
          const { Component, Layout } = path;
          return {
            path: path.route,
            element: (
              <Layout>
                <Component />
              </Layout>
            ),
          };
        }),
      // Static routes
      { path: '/callback', element: <Callback /> },
      { path: '/deployment', element: <Deployment /> },
      // Catch-all redirect
      { path: '*', element: <Navigate to='/' replace /> },
    ],
  },
]);

const root = createRoot(document.getElementById('root')!);
root.render(<RouterProvider router={router} />);
